import { render, staticRenderFns } from "./Dividend.vue?vue&type=template&id=76d33b8a&scoped=true"
import script from "./Dividend.vue?vue&type=script&lang=js"
export * from "./Dividend.vue?vue&type=script&lang=js"
import style0 from "./Dividend.vue?vue&type=style&index=0&id=76d33b8a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d33b8a",
  null
  
)

export default component.exports